const statusSolicitacao = {
    CONSOLIDADA: "Consolidada",
    CONCLUIDA: "Concluída",
    AGUARDANDO_APROVACAO_ATA: "Aguardando Aprovação - Ata",
    ATA_REPROVADA: "Ata Reprovada",
    values: () => [
      {
        id: 1,
        descricao: statusSolicitacao.CONSOLIDADA,
      },
      {
        id: 2,
        descricao: statusSolicitacao.CONCLUIDA,
      },
      {
        id: 3,
        descricao: statusSolicitacao.AGUARDANDO_APROVACAO_ATA,
      },
      {
        id: 4,
        descricao: statusSolicitacao.ATA_REPROVADA,
      },
    ],
  };
  
  export default statusSolicitacao;
  